module.exports = __webpack_public_path__ + "img/bbdc-5.4e6686bd.jpg";